import React from "react";
import {
  AboutSection,
  ArticlesSection,
  ContactSection,
  HeroSection,
  InterestsSection,
  Page,
  ProjectsSection,
  Seo,
} from "gatsby-theme-portfolio-minimal";
import { GallerySection } from "../gatsby-theme-portfolio-minimal/sections/Gallery"

export default function IndexPage() {
  return (
    <>
      <Seo title="Telecocoon, Ltd" />
      <Page useSplashScreenAnimation>
        {/*<HeroSection sectionId="hero" />*/}
        {/*<ArticlesSection sectionId="articles" />*/}
        {/*heading="Latest Articles" sources={['Medium']}*/}
        {/*<InterestsSection sectionId="details" heading="Tools" />*/}
        <GallerySection sectionId="gallery" heading="Artworks" />
        <ProjectsSection sectionId="misc" heading="Miscellaneous Projects" />
        <AboutSection sectionId="about" heading="About" />
        <ContactSection sectionId="inquiry" heading="Contact" />
      </Page>
    </>
  );
}
